<template>
  <Notification :show="notification.show" :type="notification.type" :message="notification.message" @click="this.notification.show = false" />
  <div
  class="page-header align-items-start min-vh-100"
  style="
      background-image: url('https://images.unsplash.com/photo-1497294815431-9365093b7331?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1950&q=80');
    "
  >
  <span class="mask bg-gradient-dark opacity-6"></span>
  <div class="container my-auto">
      <div class="row">
        <div class="col-lg-4 col-md-8 col-12 mx-auto">
          <div class="card z-index-0 fadeIn3 fadeInBottom">
            <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
              <div
                class="bg-gradient-success shadow-success border-radius-lg py-3 pe-1"
              >
                <h4 class="text-white font-weight-bolder text-center mt-2 mb-0">
                  Sign in
                </h4>
                <div class="row mt-3" v-if="false">
                  <div class="col-2 text-center ms-auto">
                    <a class="btn btn-link px-3" href="javascript:;">
                      <i class="fab fa-facebook text-white text-lg"></i>
                    </a>
                  </div>
                  <div class="col-2 text-center px-1">
                    <a class="btn btn-link px-3" href="javascript:;">
                      <i class="fab fa-github text-white text-lg"></i>
                    </a>
                  </div>
                  <div class="col-2 text-center me-auto">
                    <a class="btn btn-link px-3" href="javascript:;">
                      <i class="fab fa-google text-white text-lg"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <form role="form" class="text-start mt-3">
                <div class="mb-3">
                  <material-input
                    id="email"
                    type="email"
                    label="Email"
                    name="email"
                    @retrive-input-value="getValue"
                  />
                </div>
                <div class="mb-3">
                  <material-input
                    id="password"
                    type="password"
                    label="Password"
                    name="password"
                    @retrive-input-value="getValue"
                  />
                </div>
                <material-switch id="rememberMe" name="rememberMe" @click="configureCheckboxRememberMe"
                  >Remember me</material-switch
                >
                <div class="text-center">
                  <material-button
                    class="my-4 mb-2"
                    variant="gradient"
                    color="success"
                    fullWidth
                    @click.prevent="summitForm"
                    >Sign in</material-button
                  >
                </div>
                <p class="mt-4 text-sm text-center">
                  Don't have an account?
                  <router-link
                    :to="{ name: 'SignUp' }"
                    class="text-success text-gradient font-weight-bold"
                    >Sign up {{ this.form  }}</router-link
                  >
                </p>
              </form>
              <div v-if="false">
                <textarea name="cookie" v-model="form.cookie" rows="10" cols="40"> </textarea>
                <button @click.prevent="summitFormCookie"> SET </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialInput from "../components/MaterialInput.vue";
import MaterialSwitch from "../components/MaterialSwitch.vue";
import MaterialButton from "../components/MaterialButton.vue";
import { mapMutations } from "vuex";
import { httpPost } from '../services/axios'
import Notification from '../components/Notification.vue'

export default {
  name: "sign-in",
  components: {
    MaterialInput,
    MaterialSwitch,
    MaterialButton,
    Notification
  },
  beforeMount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  data () {
    return {
      form: {},
      notification: {
        show: false,
        type: null,
        message: null
      }
    }
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    getValue(inputName, inputValue) {
      this.form[inputName] = inputValue
    },
    configureCheckboxRememberMe() {
      this.form['RememberMe'] = !this.form['RememberMe']
    },
    async summitForm() {
      let res = await httpPost('/login', this.form)

      if (res.status == 200) {
        this.notification = {
                        type: 'success',
                        show: true,
                        message: 'Login successful'
        }
        document.location.href = './Dashboard'
        return
      }
      this.notification = {
                        type: 'danger',
                        show: true,
                        message: `Login failed - ${res.response.data}`
        }
    },
    async summitFormCookie() {
      let payload = JSON.parse(this.form.cookie)
      console.log(payload)
      let res = await httpPost('/cookie', payload)

      if (res.status == 200) {
        this.notification = {
                        type: 'success',
                        show: true,
                        message: 'Login successful'
        }
        // document.location.href = './Dashboard'
        return
      }
      this.notification = {
                        type: 'danger',
                        show: true,
                        message: `Login failed - ${res.response.data}`
        }
    }    
  },
};
</script>